import React, { useContext, useEffect, useCallback, useRef } from "react";
import { useLocation } from "react-router-dom";
import { AdContext } from "../../context/adContext";
import AdFreeLink from "./adFreeLink";
import { useWidthSize } from "../../hooks";
import { adData } from "../../config";
import { refreshAds } from "../../utilities/head";

export default function Billboard() {
  const previousPathname = useRef(null);
  const adDiv = useRef(null);
  const billShow = useWidthSize(["lg", "adsLG", "xl", "xxl"]);
  const { billboardDiv, billboardCreated } = useContext(AdContext);
  const location = useLocation();

  const adId = adData.divIds.billboard;

  const handleAdDiv = useCallback((node) => {
    if (node) {
      adDiv.current = billboardDiv;
      node.appendChild(billboardDiv);

      if (!billboardCreated.current) {
        billboardCreated.current = true;
      }

      refreshAds([adId]);
    }
  }, []);

  useEffect(() => {
    const nextPathname = location.pathname;

    if (previousPathname.current && previousPathname.current !== nextPathname && adDiv.current) {
      refreshAds([adId]);
    }

    previousPathname.current = nextPathname;
  }, [location]);

  if (billShow) {
    // only shown if screen is wider than "lg(1024px)"
    //  see config breakpoints

    return (
      <>
        <div data-testid="billboard-ad" className="a-billboard-container" ref={handleAdDiv} />
        <div className="a-cta">
          <AdFreeLink />
        </div>
      </>
    );
  }

  return null;
}
